import { createSelector } from 'reselect';

import type { RootState } from 'config/store/reducers';

const getState = (state: RootState) => state.app;

const getUI = createSelector(getState, (app) => app.ui);
const getModals = createSelector(getState, (app) => app.modals);

export const isConnected = createSelector(getState, (app) => app.isConnected);

export const isRefreshModalOpen = createSelector(getModals, (modals) => modals.isRefreshPageModalOpen);

export const isCookieModalOpen = createSelector(getUI, (ui) => ui.isCookieModalOpen);

export const isChatModalOpen = createSelector(getUI, (ui) => ui.isChatModalOpen);

export const isMobile = createSelector(getUI, (ui) => ui.isMobile);
